import { render, staticRenderFns } from "./SurveyTypePicker.vue?vue&type=template&id=12664594&"
import script from "./SurveyTypePicker.vue?vue&type=script&lang=js&"
export * from "./SurveyTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports